// A small fixed-position status line (bottom-left corner).
//
// Shared by the ENTRY chunk (`main.ts`: lobby, loading and health notes) and
// the lazily-loaded WORLD chunk (`game.ts`: renderer errors, the controls
// hint). It must stay dependency-free — the whole point of the (20b) code
// split is that the login/lobby screens never pull the renderer, so nothing
// imported by `main.ts` may reach three/webgpu.
//
// Returns the element so a transient note (e.g. "loading…") can be removed
// once it is stale; the pre-existing callers simply ignore the return value.
export function showMessage(host: HTMLElement, text: string): HTMLParagraphElement {
  const p = document.createElement('p')
  p.textContent = text
  p.style.cssText = 'position:fixed;left:1rem;bottom:1rem;margin:0;font-size:0.9rem;opacity:0.75;'
  host.appendChild(p)
  return p
}
